import * as angular from "angular";
import * as _ from "lodash";


angular
  .module('bringoz.admin.commons')
  .filter('bringozDistanceSymbol', bringozDistanceSymbol);

function bringozDistanceSymbol($log, splitService) {
  return function bringozDistanceSymbolFilter(distance, isSmallUnit) {

    if (_.isUndefined(distance)) {
      $log.error('Distance resolved to undefined! \n ' +
        '-->bringozDistance@bringozDistanceFilter');
      return;
    }

    var distanceConfig = isSmallUnit ?
      splitService.getSiteDistanceSmallUnit() :
      splitService.getSiteDistanceLargeUnit();

    return distance.toFixed(1).toString() + ' ' + distanceConfig;
  }
}
